import { ReactElement } from 'react';
import classes from 'classnames';
import styles from './Text.module.scss';

export type TextProps = {
  className?: string;
  contentClickHandler?: () => void;
  level?: 1 | 2 | 3;
  kind?: 'p' | 'span' | 'label';
  text?: string | ReactElement;
  weight?: 'regular' | 'medium' | 'bold';
  dangerouslySetInnerHTML?: { __html: string };
  suppressDefaultStyles?: boolean;
  dataTest?: string;
};

export default function Text({
  className,
  contentClickHandler,
  level = 1,
  kind: Tag = 'span',
  text,
  weight = 'regular',
  dangerouslySetInnerHTML,
  suppressDefaultStyles = false,
  dataTest,
}: TextProps) {
  return (
    <Tag
      className={classes(
        styles.text,
        styles[`weight-${weight}`],
        !suppressDefaultStyles && styles[`body-${level}`],
        className,
      )}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      data-test={dataTest}
      onClick={contentClickHandler}
    >
      {dangerouslySetInnerHTML ? undefined : text}
    </Tag>
  );
}
